export function countColors(numColors: number, grid: number[][]) {
  const currentColorCounts = Array(numColors+1).fill(0)  // feels bad
  for (const row of grid) {
    for (const cell of row) {
      currentColorCounts[cell]++
    }
  }
  return currentColorCounts
}
